import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { LoggerErrorHandler } from './logger-error-handler';

const providers = [];

if (environment.production) {
  providers.push({
    provide: ErrorHandler,
    useClass: LoggerErrorHandler,
  });
}

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    SharedModule,
    AppRoutingModule,
  ],
  bootstrap: [AppComponent],
  providers,
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts